import { IApiError } from '@/models/apiError.model';
import { IGoogleMerchantSyncRun } from '@/models/googleMerchantSync.model';
import { IPaginationResponse } from '@/models/pagination.model';

export const SLICE_NAME = 'googleMerchantSync';

export interface IGoogleMerchantSyncState {
  isLoading: boolean;
  error: IApiError | null;
  syncRuns: IGoogleMerchantSyncRun[] | null;
  pagination: IPaginationResponse | null;
}

export const initialState: IGoogleMerchantSyncState = {
  isLoading: false,
  error: null,
  syncRuns: null,
  pagination: null,
};
